import DashboardLayout from '../../../shared/DashboardLayout';

const Formulas = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default Formulas
